import React, { useContext, useEffect, useCallback } from "react";
import { useState } from "react";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import {
  getEmployeeDetailsData,
  GetSummaryCards,
} from "./Service/EmployeeExitService";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { string } from "yup";
import { Dropdown } from "primereact/dropdown";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { MultiSelect } from "primereact/multiselect";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import { FloatLabel } from "primereact/floatlabel";
const defaultImage = "/images/placeholder_profile.png";

function InitiateEmployeeExitList() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [exitEmployeeList, setExitEmployeeList] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [masterExitStatusData, setMasterExitStatusData] = useState([]);
  const [masterFnFStatusData, setMasterFnFStatusData] = useState([]);
  const [masterExitTypeData, setMasterExitTypeData] = useState([]);
  const [selectedExitStatus, setSelectedExitStatus] = useState([]);
  const [selectedFnFStatus, setSelectedFnFStatus] = useState([]);
  const [selectedExitType, setSelectedExitTypeStatus] = useState([]);
  const [selectedLastWorkingEndDate, setSelectedLastWorkingEndDate] =
    useState();
  const [selectedLastWorkingStartDate, setSelectedLastWorkingStartDate] =
    useState();
  const [selectedInitiateStartDate, setSelectedInitiateStartDate] = useState();
  const [selectedInitiateEndDate, setSelectedInitiateEndDate] = useState();
  const toster = useContext(TostMsg);
  const [summaryCardData, setSummaryCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    if (!debouncedSearchTerm) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    }
    getMasterExitStatus();
    getMasterFnFStatus();
    getMasterExitTypeStatus();
    getSummaryCards();
  }, []);

  async function getInitiateEmployeeExitListData(
    pageNumber,
    pageSize,
    debouncedSearchTerm
  ) {
    const params = {
      Id: 0,
      EmpId: 0,
      Guid: "",
      LoggedInUserId: 0,
      filterLastWorkingStartDate: selectedLastWorkingStartDate
        ? new Date(selectedLastWorkingStartDate)?.toISOString()
        : "",
      filterLastWorkingEndDate: selectedLastWorkingEndDate
        ? new Date(selectedLastWorkingEndDate)?.toISOString()
        : "",
      Search: searchInput ? searchInput : "",
      Exitstatus: selectedExitStatus ? selectedExitStatus.toString() : "",
      FnFstatus: selectedFnFStatus ? selectedFnFStatus.toString() : "",
      ExitType: selectedExitType ? selectedExitType.toString() : "",
      filterStartDate: selectedInitiateStartDate
        ? new Date(selectedInitiateStartDate)?.toISOString()
        : "",
      filterEndDate: selectedInitiateEndDate
        ? new Date(selectedInitiateEndDate)?.toISOString()
        : "",
      OrgId: userDetails?.OrgId,
      StatusId: 0,
      PageNumber: 1,
      PageSize: 10000,
    };
    try {
      const data = await getEmployeeDetailsData(params);
      let exitemployeesDetails = await data;
      if (exitemployeesDetails) {
        setExitEmployeeList(exitemployeesDetails?.Data);
        setTotalRecords(exitemployeesDetails?.Data?.length);
      }
    } catch {
      // setIsloading(false);
      // toster.current.error("Something went wrong");
    } finally {
      // if (romoveDuplicateData.length === 0) {
      //   setTicketDataMessage("NO DATA FOUND.");
      // }
    }
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="d-flex">
        <Link
          to={`/Employee/Exit/${rowData.Guid}`}
          href
          className="view-teamdetail"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-eye"
            viewBox="0 0 16 16"
          >
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"></path>
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"></path>
          </svg>
        </Link>
      </div>
    );
  };

  const lastWorkingDate = (rowData) => {
    return (
      <div>{`${new Date(rowData?.LastWorkingDate).toLocaleDateString()}`}</div>
    );
  };

  const InitiatedDate = (rowData) => {
    return (
      <div>{`${new Date(rowData?.InitiatedDate).toLocaleDateString()}`}</div>
    );
  };

  const employeeDetails = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.EmpGUID}`}>
        <div className="d-flex align-items-center">
          <img
            src={rowData?.ProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width={24}
            alt=""
          />{" "}
          <span className="w-space-no">
            {rowData?.EmployeeName} ({rowData?.EmpId})
          </span>
        </div>
      </Link>
    );
  };

  const EmployeeReason = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        <span>
          {rowData?.Reason1?.length > 0 && (
            <span
              className="w-space-no"
              style={{ cursor: "pointer" }}
              title={`${rowData.Reason1} ${rowData.Reason2}`}
            >
              {rowData.Reason1.slice(0, 10)}...
            </span>
          )}
        </span>
      </div>
    );
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const [formValues, setFormValues] = useState({
    InitiateStartDate: "",
    InitiateEndDate: "",
    LWStartDate: "",
    LWEndDate: "",
  });
  async function handleInputChange(e) {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setSearchTerm({ [name]: value });
  }

  useEffect(() => {
    if (selectedExitStatus) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedExitType) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedFnFStatus) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedInitiateStartDate) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedInitiateEndDate) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedLastWorkingStartDate) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    } else if (selectedLastWorkingEndDate) {
      getInitiateEmployeeExitListData(
        currentPage,
        rowsPerPage,
        debouncedSearchTerm
      );
    }
  }, [
    currentPage,
    rowsPerPage,
    debouncedSearchTerm,
    selectedExitStatus,
    selectedExitType,
    selectedFnFStatus,
    selectedInitiateStartDate,
    selectedInitiateEndDate,
    selectedLastWorkingStartDate,
    selectedLastWorkingEndDate,
  ]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearchTerm(searchInput);
      handleInputChange({ target: { value: searchInput } });
    }, 500);

    return () => clearTimeout(timeout);
  }, [searchInput]);

  async function getMasterExitStatus() {
    const params = {
      masterType: "ExitStatus",
      organisationId: userDetails?.OrgId,
    };
    try {
      setIsloading(true);
      let exitStatusData = await GetMasterTypeData(params);
      setMasterExitStatusData(exitStatusData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterFnFStatus() {
    const params = {
      masterType: "FnFStatus",
      organisationId: userDetails?.OrgId,
    };
    try {
      setIsloading(true);
      let fnfStatusData = await GetMasterTypeData(params);
      setMasterFnFStatusData(fnfStatusData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getMasterExitTypeStatus() {
    const params = {
      masterType: "ExitType",
      organisationId: userDetails?.OrgId,
    };
    try {
      setIsloading(true);
      let exitTypeData = await GetMasterTypeData(params);
      setMasterExitTypeData(exitTypeData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getSummaryCards() {
    try {
      setIsloading(true);
      let summaryCardsData = await GetSummaryCards();
      setSummaryCardData(summaryCardsData?.Data);
      setIsloading(false);
    } catch {
      setIsloading(false);
    }
  }

  return (
    <div>
      <div className="container-fluid position-relation">
        <div className="row g-3 initiate-exit-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Exit Dashboard</h2>
              </div>
            </div>
            <div className="form-head d-flex flex-wrap align-items-center bottom-head">
              {/* <span className="fil-name">Filter</span> */}
              <div className="saving-btn00 d-flex w-100">
                <div className="d-flex d-flexx">
                  <MultiSelect
                    name="exitStatus"
                    className="w-full md:w-14rem"
                    filter
                    optionLabel="Name"
                    maxSelectedLabels={2}
                    optionValue="Id"
                    placeholder="Exit Status"
                    value={selectedExitStatus} // should be array of Ids: [1, 2]
                    options={masterExitStatusData}
                    onChange={(e) => {
                      setSelectedExitStatus(e.value);
                      handleInputChange(e);
                    }}
                  />
                  <MultiSelect
                    name="FnFStatus"
                    className="w-full md:w-14rem"
                    optionLabel="Name"
                    maxSelectedLabels={2}
                    optionValue="Id"
                    placeholder="FnF Status"
                    value={selectedFnFStatus}
                    options={masterFnFStatusData}
                    onChange={(e) => {
                      setSelectedFnFStatus(e.value);
                      handleInputChange(e);
                    }}
                  />
                  <MultiSelect
                    name="ExitType"
                    optionLabel="Name"
                    optionValue="Id"
                    maxSelectedLabels={2}
                    filter
                    placeholder="Exit Type"
                    className="w-full md:w-14rem"
                    value={selectedExitType}
                    options={masterExitTypeData}
                    onChange={(e) => {
                      setSelectedExitTypeStatus(e.value);
                      handleInputChange(e);
                    }}
                  />
                  <span className="startdatefilter">Initiate Date</span>

                  <InputText
                    // type="date"
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = "text";
                    }}
                    name="InitiateStartDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    placeholder="Start Date"
                    className="form-control mr-2"
                    value={selectedInitiateStartDate || ""}
                    onChange={(e) => {
                      setSelectedInitiateStartDate(e.target.value);
                      handleInputChange(e);
                    }}
                  />

                 

                  <InputText
                    // type="date"
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = "text";
                    }}
                    name="InitiateEndDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    placeholder="End Date"
                    className="form-control mr-2"
                    value={selectedInitiateEndDate}
                    onChange={(e) => {
                      setSelectedInitiateEndDate(e.target.value);
                      handleInputChange(e);
                    }}
                  />
                  <span className="enddatefilter">Last working Date</span>
                  <InputText
                    // type="date"
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = "text";
                    }}
                    name="LWStartDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    placeholder="Start Date"
                    className="form-control mr-2"
                    value={selectedLastWorkingStartDate}
                    onChange={(e) => {
                      setSelectedLastWorkingStartDate(e.target.value);
                      handleInputChange(e);
                    }}
                  />
                  <InputText
                    // type="date"
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => {
                      if (!e.target.value) e.target.type = "text";
                    }}
                    name="LWEndDate"
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                    placeholder="End Date"
                    className="form-control mr-2"
                    value={selectedLastWorkingEndDate}
                    onChange={(e) => {
                      setSelectedLastWorkingEndDate(e.target.value);
                      handleInputChange(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="tickets-summary">
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Total Exits</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.TotalExit}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green">
                        {summaryCardData[0]?.AttritionRate}{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-trending-up"
                        >
                          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                          <polyline points="17 6 23 6 23 12"></polyline>
                        </svg>
                      </span>
                      <span>Attrition Rate</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Voluntary Exits</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.VoluntaryExit}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green">
                        {summaryCardData[0]?.VoluntaryAttritionRate}{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-trending-up"
                        >
                          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                          <polyline points="17 6 23 6 23 12"></polyline>
                        </svg>
                      </span>
                      <span>Attrition Rate</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Involuntary Exits</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.InVoluntaryExit}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green">
                        {summaryCardData[0]?.InVoluntaryAttritionRate}{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="feather feather-trending-up"
                        >
                          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                          <polyline points="17 6 23 6 23 12"></polyline>
                        </svg>
                      </span>
                      <span>Attrition Rate</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg Tenure Before Exit</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.AvgTenure}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>In Months</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">Avg Notice Period</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.AvgNoticePeriod}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>In Months</span>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <img src="images/org-img/leave/popup-backimg.png" />
                  <div className="dashboard-tile">
                    <div className="tile-head">
                      <h3 className="dark-inverted">FnF Pending</h3>
                      <div className="h-icon is-primary is-rounded is-small">
                        <i aria-hidden="true" className="fas fa-gem"></i>
                      </div>
                    </div>
                    <div className="tile-body">
                      <span className="dark-inverted">
                        {summaryCardData[0]?.FnfPending}
                      </span>
                    </div>
                    <div className="tile-foot">
                      <span className="text-h-green"></span>
                      <span>In Months</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto mb-3">
                    <strong
                      className="ticket-title m-0"
                      style={{ fontWeight: "bolder" }}
                    >
                      Resigned Employees
                    </strong>
                  </div>
                  <div className="actionbutton-exit">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                      value={searchInput}
                      onChange={(e) => {
                        setSearchInput(e.target.value);
                        handleInputChange(e);
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="table table-bordered dataTable no-footer teamtablelist">
                    <DataTable
                      value={exitEmployeeList}
                      paginator
                      rows={rowsPerPage}
                      totalRecords={totalRecords}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                      dataKey="Id"
                      tableStyle={{ minWidth: "50rem", fontSize: "12px" }}
                      rowClassName={(data, index) =>
                        index % 2 === 0 ? "even" : "odd"
                      }
                      emptyMessage="No exit employees found."
                    >
                      <Column
                        body={employeeDetails}
                        field="EmployeeName"
                        header="Name"
                        sortable
                      ></Column>
                      <Column
                        field="CurrentDesignation"
                        header="Designation"
                      ></Column>
                      <Column
                        field="CurrentDepartment"
                        header="Department"
                      ></Column>
                      <Column field="Email" header="Email Id"></Column>
                      <Column field="Phone" header="Phone"></Column>
                      <Column
                        field="InitiatedDate"
                        body={InitiatedDate}
                        header="Initiated date"
                      ></Column>
                      <Column
                        field="LastWorkingDate"
                        body={lastWorkingDate}
                        header="Last working Date"
                      ></Column>
                      <Column
                        field="EmployeeReason"
                        body={EmployeeReason}
                        header="Intitate Reason"
                      ></Column>
                      <Column
                        field="OverseerName"
                        header="Reporting Manager"
                      ></Column>
                      <Column field="HRManager" header="HR Manager"></Column>
                      {/* body={statusCode} */}
                      <Column field="ExitStatusName" header="Status"></Column>
                      <Column
                        field="currentbusinessunit"
                        header="Business Unit"
                      ></Column>
                      <Column
                        field="ExitTypeName"
                        header="Exit Type - V/NV"
                      ></Column>
                      <Column field="NoticeDays" header="Notice Days"></Column>
                      <Column field="FNFStatusName
                      " header="FnF Status"></Column>
                      <Column field="IsBuyOut" header="BuyOut"></Column>
                      <Column
                        header="Action"
                        body={actionBodyTemplate}
                        style={{ width: "70px" }}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
}

export default InitiateEmployeeExitList;
